<script>
  import MapTool from "./MapTool.svelte";
  import { FontsUrban } from "@urbaninstitute/dataviz-components";
  import state_data from "$data/map/state.csv";
  import county_data from "$data/map/county.csv";
  import config_data from "$data/map/config.csv";
</script>

<svelte:options customElement="map-tool" />

<FontsUrban />
<MapTool
  data={state_data}
  tableData={county_data}
  configData={config_data}
  mapType="hex"
  showStateSummary="false"
  dropdownLabel=""
  hideDropdown="true"
  tablePlaceholderLabel="Select a state or district to see data by county"
/>
